import axios from "axios";
import { getAuthStorage } from "./contexts/AuthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const isProduction = process.env.NODE_ENV === "production";
const isStaging = process.env.NODE_ENV === "staging";


const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  },
});

httpClient.interceptors.request.use(
  function (config) {
    config.headers.common["x-auth-token"] = getAuthStorage().authToken;
    return config;
  },
  function (error) {
    console.error("axios.interceptors.request error => ", error);
    return Promise.reject(error);
  }
);

export default httpClient;
